import React from "react";
import SimpleTodayPage from "./SimpleTodayPage";

const SimpleApp = () => {
  // Read pool_id from URL query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const poolParam = urlParams.get("pool");
  const pool_id = poolParam ? parseInt(poolParam, 10) : 6; // Default to Soccer 6

  return <SimpleTodayPage pool_id={pool_id} />;
};

export default SimpleApp;
